var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{staticClass:"elevation-0 transparent plant-toolbar",attrs:{"height":"40px"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }